import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button, Modal, Form } from 'react-bootstrap';
import { getAllRequests } from '../actions/requestActions';
import { useDispatch, useSelector } from 'react-redux';
import { RequestStatus } from '../enums/requestStatus';
import arrowRightImage from '../assets/arrow-small-right.png';
import mcProceso from '../assets/mcProceso.png';
import moment from 'moment';
import { createProposal, getAllProposals, evaluateProposal, getAllJury, getAllExternalJury, saveProposalJury, getProposalJury, evaluateProposalFinal } from '../actions/proposalActions';
import { ProposalStatus } from '../enums/proposalStatus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { notifySuccess, notifyError } from './Toast';
import { createExternalUser } from '../actions/userActions';
import { JuryRoles } from '../enums/juryRoles';
import AssignProposalJuryModal from './AssignProposalJuryModal';

const Dashboard = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { requests, loading, error } = useSelector(state => state.request);
    const { proposals } = useSelector(state => state.proposal);
    const { userInfo } = useSelector(state => state.user);

    const [activeTab, setActiveTab] = useState('solicitudes');
    const [filter, setFilter] = useState('all');
    const [activeProposal, setActiveProposal] = useState('')
    const [showModal, setShowModal] = useState(false);

    const safeRequests = Array.isArray(requests) ? requests : [];
    const safeProposals = Array.isArray(proposals) ? proposals : [];

    const filterItemsByState = (items = [], filter) => {
        if (filter === 'all') return items;
        return items.filter(item => item?.estado?.Id?.toUpperCase() === filter);
    };

    const filteredRequests = filterItemsByState(safeRequests, filter);
    const filteredProposals = filterItemsByState(safeProposals, filter);

    const isJuryRole = userInfo.roles != undefined ? (userInfo.roles.includes('jurado') || userInfo.roles.includes('AdminMicrocredencial')) : false;
    const isAdminRole = userInfo.roles != undefined ? userInfo.roles.includes('AdminMicrocredencial') : false;

    const canEditProposal = (proposal) => {
        if (!proposal) return false;
        const isOwner = proposal.id_usuario === userInfo.id;
        return (isAdminRole && isOwner) || (!isAdminRole && isOwner);
    };

    const handleFilterClick = (status, event) => {
        event.preventDefault();
        setFilter(prevFilter => prevFilter === status ? 'all' : status);
    };

    const handleRequestDetail = (requestId) => {
        navigate(`/backoffice/request-detail/${requestId}`);
    };

    useEffect(() => {
        dispatch(getAllRequests(userInfo));
        dispatch(getAllProposals(userInfo));
        setFilter('all');
    }, [activeTab, dispatch, userInfo]);

    // Verificar si el usuario está autenticado
    useEffect(() => {
        if (!userInfo || userInfo.Authenticated === false) {
            navigate('/');
            return;
        }
    }, [userInfo, navigate]);

    const handleLoadApplicationForm = (requestId) => {
        const requestData = {
            solicitud: {
                Id: requestId
            },
            estado: {
                Id: ProposalStatus.EnEdicion.id
            }
        };

        dispatch(createProposal(requestData, userInfo, navigate,true));
    };

    const handleLoadApplicationFormEdition = (requestId, proposalId) => {
       
         const proposal = safeProposals.find(p => p.Id === proposalId);
         const canEdit = canEditProposal(proposal);

         const requestData = {
            Id: proposalId,
            solicitud: {
                Id: requestId
            },
            estado: {
                Id: ProposalStatus.EnEdicion.id
            }
        };

        dispatch(createProposal(requestData, userInfo, navigate,canEdit));
    };

    const handleLoadApplicationFormJuryEdition = (requestId, proposal) => {

        let estadoId = ProposalStatus.EnEvaluacion.id;
        //proposal.esJuezSupremo = false;

        if (proposal.esUsuarioResponsable) {
            estadoId = ProposalStatus.EnDictamenFinal.id;
        }

        const requestData = {
            Id: proposal.Id,
            solicitud: {
                Id: requestId
            },
            estado: {
                Id: estadoId
            }
        };

        dispatch(evaluateProposal(requestData, userInfo, navigate));
    };

    const hasFinalStatus = (proposal) => {

        var isValid = false;
        switch (proposal.estado.Id.toUpperCase()) {
            case ProposalStatus.AceptadaConObservaciones.id:
            case ProposalStatus.Aprobada.id:
            case ProposalStatus.Rechazada.id:
                isValid = true;
                break;

            default:
                break;
        }

        return isValid;
    };

    const handleLoadProposalDetail = (requestId, proposal) => {

        let estadoId = ProposalStatus.EnDictamenFinal.id;

        const requestData = {
            Id: proposal.Id,
            solicitud: {
                Id: requestId
            },
            estado: {
                Id: estadoId
            }
        };

        dispatch(evaluateProposalFinal(requestData, userInfo, navigate));
    };

    const handleOpenAssignmentJury = (proposal) => {
        setActiveProposal(proposal.Id);
        setShowModal(true);
    };

    const handleCloseAssignmentJury = () => {
        setActiveProposal(null);
        setShowModal(false);
    };

    let pendingCount = 0;
    let approvedCount = 0;
    let rejectedCount = 0;
    let proposalInitiated =0;

    safeRequests.forEach(request => {
        const estadoId = request?.estado?.Id?.toUpperCase();
        if (estadoId === RequestStatus.Pendiente.id) {
            pendingCount++;
        } else if (estadoId === RequestStatus.Aprobada.id) {
            approvedCount++;
        } else if (estadoId === RequestStatus.Rechazada.id) {
            rejectedCount++;
        } else if (estadoId === RequestStatus.PropuestaIniciada.id) {
            proposalInitiated++;
        }
    })

    let pendingProposalCount = 0;
    let approvedProposalCount = 0;
    let rejectedProposalCount = 0;
    let inEditionProposalCount = 0;
    let acceptedObservationsProposalCount=0;
    let inAssessmentProposalCount=0;
    let inFinalOpinionProposalCount=0;

    safeProposals.forEach(pr => {
        const estadoId = pr?.estado?.Id?.toUpperCase();
        if (estadoId === ProposalStatus.Pendiente.id) {
            pendingProposalCount++;
        } else if (estadoId === ProposalStatus.Aprobada.id) {
            approvedProposalCount++;
        } else if (estadoId === ProposalStatus.Rechazada.id) {
            rejectedProposalCount++;
        } else if (estadoId === ProposalStatus.EnEdicion.id) {
            inEditionProposalCount++;
        } else if (estadoId === ProposalStatus.AceptadaConObservaciones.id) {
            acceptedObservationsProposalCount++;
        } else if (estadoId === ProposalStatus.EnEvaluacion.id) {
            inAssessmentProposalCount++;
        } else if (estadoId === ProposalStatus.EnDictamenFinal.id) {
            inFinalOpinionProposalCount++;
        }
    })
    
    return (
        <>
            <AssignProposalJuryModal
                show={showModal}
                onHide={handleCloseAssignmentJury}
                activeProposal={activeProposal}
            />
            {!isJuryRole ? (
                <section className="container bienvenida">
                    <h2>¡Bienvenido/a, <span style={{ color: "#F20A61" }}>{userInfo.userName}</span>!</h2>
                    <div className="bienvenida1">
                        <div className='col-12'>
                            <div className='row'>
                                <div className='col-lg-6 col-md-12'>
                                    <p className='parrafo-bienvenida'>¡Gracias por mostrar interés en diseñar una microcredencial!<br /><br /> En la UAI, apreciamos tu iniciativa y te brindamos el respaldo necesario para crear una propuesta de alto valor y calidad, alineada con nuestros estándares educativos de excelencia.
                                        <br /><br />
                                        Por favor, envianos tu propuesta completando la solicitud inicial. Considerá los tiempos previstos para cada etapa ya que son fijos e inamovibles y organizan todo el proceso. Compartimos una línea de tiempo para que puedas agendarlos.</p>
                                    <br />
                                </div>
                                {requests.length > 0 &&
                                    <div className='col-6'>
                                        <img src={mcProceso} style={{ width: '100%' }} alt="" />
                                    </div>
                                }
                            </div>
                            <div className='row aprobSolicitud'>
                                <div className='col-lg-6 col-md-12'>
                                    <div className="alcance_content mt-3 Dash">
                                        <img src={arrowRightImage} alt="" />
                                        <p>La aprobación de la solicitud inicial es un requisito para presentar el proyecto completo.</p>
                                    </div>
                                </div>
                                <div className='row aprobSolicitud'>
                                    
                                    <div className='col-lg-12'>
                                        <div className="caption1 StartHere mt-3">
                                            <p href="#">Comenzá por Aquí</p>
                                            <Link to="/backoffice/new-request" >

                                                <img src={arrowRightImage} alt="" style={{ marginLeft: '40px' }} />
                                                <Button variant="primary" className="btn">
                                                    Solicitud inicial
                                                </Button>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section >)
                :
                (<section className="container bienvenida">
                    <h2>¡Bienvenido/a, <span style={{ color: "#F20A61" }}>{userInfo.userName}</span>!</h2>
                    <div>
                        <div className='row'>
                            <div className='col-12'>
                                <div className="first_col">
                                    <p>Aquí podrás ver listadas las solicitudes enviadas por los creadores de las microcredenciales para ser evaluadas.</p>
                                </div>
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-lg-6 col-md-12'>
                                <div className="alcance_content mt-3">
                                    <img className='imgArrow' src={arrowRightImage} alt="" />
                                    <p>La aprobación de la solicitud inicial es un requisito para presentar el proyecto completo.</p>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-12'>
                                    
                                </div>
                                <div className='col-lg-6 col-md-12 '>
                                    <div className="caption1 mt-3 text-center designe-start">
                                        <p href="#">Comenzá por Aquí</p>
                                        <Link to="/backoffice/new-request" >

                                            <img src={arrowRightImage} alt="" />{/*style={{ marginLeft: '40px' }} />*/}
                                            <Button variant="primary" className="btn">
                                                Solicitud inicial
                                            </Button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >)
            }
            {requests.length > 0 ?
                <section className="container mt-5">
                    <div className='col-12 mb-5'>
                        <div className='row'>
                            <div className='col-6 col-sm-6 col-md-4' onClick={() => setActiveTab('solicitudes')}>
                                <div className={`solicitudes-iniciales-parent ${activeTab === 'solicitudes' ? 'active' : ''}`}>
                                    <b className="solicitudes-iniciales">Solicitudes iniciales</b>
                                    <div className={`wrapper ${activeTab === 'solicitudes' ? 'active' : ''}`}>
                                        <b className="solicitudes-iniciales">{requests.length || 0}</b>
                                    </div>
                                </div>
                            </div>
                            <div className='col-6 col-sm-6 col-md-4' onClick={() => setActiveTab('microcredenciales')}>
                                <div className={`proyecto-microcredenciales-parent ${activeTab === 'microcredenciales' ? 'active' : ''}`}>
                                    <b className="proyecto-microcredenciales">Proyecto microcredenciales</b>
                                    <div className={`wrapper_ns ${activeTab === 'microcredenciales' ? 'active' : ''}`}>
                                        <b className="proyecto-microcredenciales">{proposals.length || 0}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row'>


                            <div className="tab-content">
                                {activeTab === 'solicitudes' ? (
                                    <div className="active">
                                        <div className="solicitudes" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <ul>
                                                <li>
                                                <button
                                                    onClick={(e) => handleFilterClick(RequestStatus.Pendiente.id, e)}
                                                    className={`card_solicitud ${filter === RequestStatus.Pendiente.id ? "active" : ""}`}
                                                >
                                                    Pendientes <span style={{ paddingLeft: "30px" }}> {pendingCount}</span>
                                                </button>
                                                </li>
                                                <li>
                                                <button
                                                    onClick={(e) => handleFilterClick(RequestStatus.Aprobada.id, e)}
                                                    className={`card_solicitud ${filter === RequestStatus.Aprobada.id ? "active" : ""}`}
                                                >
                                                    Aprobadas <span style={{ paddingLeft: "30px" }}>{approvedCount}</span>
                                                </button>
                                                </li>
                                                <li>
                                                <button
                                                    onClick={(e) => handleFilterClick(RequestStatus.Rechazada.id, e)}
                                                    className={`card_solicitud ${filter === RequestStatus.Rechazada.id ? "active" : ""}`}
                                                >
                                                    Rechazadas <span style={{ paddingLeft: "30px" }}>{rejectedCount}</span>
                                                </button>
                                                </li>
                                                <li>
                                                <button
                                                    onClick={(e) => handleFilterClick(RequestStatus.PropuestaIniciada.id, e)}
                                                    className={`card_solicitud ${filter === RequestStatus.PropuestaIniciada.id ? "active" : ""}`}
                                                >
                                                    Propuestas Iniciadas <span style={{ paddingLeft: "30px" }}>{proposalInitiated}</span>
                                                </button>
                                                </li>
                                            </ul>
                                        </div>
                                        {loading ? (
                                            <p>Cargando...</p>
                                        ) : error ? (
                                            <p>Error: {error}</p>
                                        ) : (
                                        <div style={{ maxHeight: '450px', overflowY: 'auto'}}> 
                                            <table>
                                                <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                                    <tr className="table_head">
                                                        {isJuryRole && <th></th>}
                                                        {isJuryRole && <th>Nombre solicitante</th>}
                                                        <th>Nombre</th>
                                                        <th>Fecha</th>
                                                        <th>Estado</th>
                                                        <th>Acciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredRequests.sort((a, b) => new Date(b.fechaSolicitud) - new Date(a.fechaSolicitud))
                                                        .map(request => (
                                                            <tr key={request.Id}>
                                                                {isJuryRole && <td className='text-center'> {request.esExterna ? <FontAwesomeIcon icon={faGlobe} title='Solicitud Externa' /> : null}</td>}
                                                                {isJuryRole && <td> {request.usuario.email || request.usuario.EntityId || '[No disponible]'}</td>}
                                                                <td>{request.nombre}</td>
                                                                <td>{moment(request.fechaSolicitud).format('DD-MM-YYYY')}</td>
                                                                <td>{request.estado.estado}</td>
                                                                <td>
                                                                    {request.estado && (
                                                                    <div className="dropdown mt-1 mb-1">
                                                                        <a className="btnDropdown btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                                                            <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                        </a>
                                                                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                                            {request.usuario.EntityId == userInfo.id && request.estado && request.estado.Id.toUpperCase() === RequestStatus.Aprobada.id &&(
                                                                                <li><a className="dropdown-item" onClick={() => handleLoadApplicationForm(request.Id)}>Iniciar formulario</a></li>
                                                                            )}
                                                                            {request.estado &&(
                                                                                <li><a className="dropdown-item" onClick={() => handleRequestDetail(request.Id)}>Ver detalle</a></li>
                                                                            )}
                                                                        </ul>
                                                                    </div>)}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>    
                                        )}
                                    </div>
                                ) : (
                                    <div className="active">
                                        <div className="solicitudes">
                                            <ul>
                                                <li>
                                                    <button
                                                        onClick={(e) => handleFilterClick(ProposalStatus.Pendiente.id, e)}
                                                        className={`card_solicitud ${filter === ProposalStatus.Pendiente.id ? "active" : ""}`}
                                                    >
                                                        Pendientes <span style={{ paddingLeft: '30px' }}> {pendingProposalCount}</span>
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        onClick={(e) => handleFilterClick(ProposalStatus.Aprobada.id, e)}
                                                        className={`card_solicitud ${filter === ProposalStatus.Aprobada.id ? "active" : ""}`}
                                                    >
                                                        Aprobadas <span style={{ paddingLeft: '30px' }}>{approvedProposalCount}</span>
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        onClick={(e) => handleFilterClick(ProposalStatus.Rechazada.id, e)}
                                                        className={`card_solicitud ${filter === ProposalStatus.Rechazada.id ? "active" : ""}`}
                                                    >
                                                        Rechazadas <span style={{ paddingLeft: '30px' }}>{rejectedProposalCount}</span>
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        onClick={(e) => handleFilterClick(ProposalStatus.EnEdicion.id, e)}
                                                        className={`card_solicitud ${filter === ProposalStatus.EnEdicion.id ? "active" : ""}`}
                                                    >
                                                        En edición <span style={{ paddingLeft: '30px' }}>{inEditionProposalCount}</span>
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        onClick={(e) => handleFilterClick(ProposalStatus.AceptadaConObservaciones.id, e)}
                                                        className={`card_solicitud ${filter === ProposalStatus.AceptadaConObservaciones.id ? "active" : ""}`}
                                                    >
                                                        Aceptada con observaciones <span style={{ paddingLeft: '30px' }}>{acceptedObservationsProposalCount}</span>
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        onClick={(e) => handleFilterClick(ProposalStatus.EnEvaluacion.id, e)}
                                                        className={`card_solicitud ${filter === ProposalStatus.EnEvaluacion.id ? "active" : ""}`}
                                                    >
                                                        En evaluación <span style={{ paddingLeft: '30px' }}>{inAssessmentProposalCount}</span>
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        onClick={(e) => handleFilterClick(ProposalStatus.EnDictamenFinal.id, e)}
                                                        className={`card_solicitud ${filter === ProposalStatus.EnDictamenFinal.id ? "active" : ""}`}
                                                    >
                                                        En dictamen final <span style={{ paddingLeft: '30px' }}>{inFinalOpinionProposalCount}</span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        {loading ? (
                                            <p>Cargando...</p>
                                        ) : error ? (
                                            <p>Error: {error}</p>
                                        ) : (
                                            <>
                                            <div style={{ maxHeight: '450px', overflowY: 'auto'}}>
                                                <table>
                                                    <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                                        <tr className="table_head">
                                                            {isJuryRole && <th>Nombre solicitante</th>}
                                                            <th>Nombre</th>
                                                            <th>Fecha</th>
                                                            <th>Estado</th>
                                                            <th>Acciones</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {filteredProposals.sort((a, b) => new Date(b.solicitud.fechaSolicitud) - new Date(a.solicitud.fechaSolicitud))
                                                            .map(pr => (
                                                                <tr key={pr.Id}>
                                                                    {isJuryRole && <td> {pr.id_usuario}</td>}
                                                                    <td>{pr.solicitud.nombre}</td>
                                                                    <td>{moment(pr.solicitud.fechaSolicitud).format('DD-MM-YYYY')}</td>
                                                                    <td>{pr.estado.estado}</td>
                                                                    <td>
                                                                        {hasFinalStatus(pr) ? <div></div> : (
                                                                            <div className="dropdown mt-1 mb-1">
                                                                                <a className="btnDropdown btn-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                    <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                                </a>
                                                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                                                                    {canEditProposal(pr) && pr.estado && pr.estado.Id.toUpperCase() === ProposalStatus.EnEdicion.id &&
                                                                                        <li><a className="dropdown-item" onClick={() => handleLoadApplicationFormEdition(pr.solicitud.Id, pr.Id)}>Completar formulario</a></li>}
                                                                                    {isAdminRole && 
                                                                                    (<li><a className="dropdown-item" id="modalAsignacion" onClick={() => handleOpenAssignmentJury(pr)}>Asignar evaluadores</a></li>)}
                                                                                    {isAdminRole && pr.id_usuario !== userInfo.id && 
                                                                                    (<li><a className="dropdown-item" id="modalAsignacion" onClick={() => handleLoadApplicationFormEdition(pr.solicitud.Id,pr.Id)}>Visualizar propuesta parcial</a></li>)}
                                                                                    {pr.esJuez && pr.estado && !pr.estado.evaluada && pr.estado.Id.toUpperCase() !== ProposalStatus.EnEdicion.id && (
                                                                                        <li><a className="dropdown-item" onClick={() => handleLoadApplicationFormJuryEdition(pr.solicitud.Id, pr)}>Evaluar</a></li>
                                                                                    )}
                                                                                    {pr.esUsuarioResponsable && pr.estado && pr.estado.Id.toUpperCase() === ProposalStatus.EnDictamenFinal.id && (
                                                                                        <li><a className="dropdown-item" onClick={() => handleLoadProposalDetail(pr.solicitud.Id, pr)}>Dar dictamen final</a></li>
                                                                                    )}
                                                                                </ul>
                                                                            </div>
                                                                        )}

                                                                    </td>

                                                                </tr>
                                                            ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            { isAdminRole && (
                                                <div style={{display: 'flex', marginTop: '2.5rem', gap: '1rem', alignItems: 'center'}}>
                                                    <p style={{fontSize: '20px', color: '#575757'}}>
                                                        Puedes previsualizar la estructura y las preguntas del formulario sin guardar respuestas:
                                                    </p>
                                                    <Button
                                                        id="verFormularioButton" 
                                                        variant="primary"
                                                        className="btn"
                                                        style={{fontSize: '14px', padding: '10px 15px'}} 
                                                        onClick={() => navigate('/backoffice/applicationform/0000')}
                                                    >
                                                        Ver formulario
                                                    </Button>
                                                </div>
                                            )}
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
                :
                <section className="container mt-5">
                    <div className='col-12 mb-5'>
                        <div className='row'>
                            <div className="alcance_content">
                                <img src={mcProceso} style={{ width: '100%' }} alt="" />
                            </div>
                        </div>
                    </div>
                </section>
            }
        </>
    );
};

export default Dashboard;
